import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable, of, Subject } from 'rxjs'
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { Organization } from '../organization'
import { organizationActions } from '../organization.actions'
import { organizationSelectors } from '../organization.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { OrganizationService } from '../organization.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'organization-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationGeneralTabComponent implements OnInit {
  public organization$: Observable<Organization>
  public organizationId$: Observable<number>
  public form: UntypedFormGroup
  public accessRights = AccessRights
  public disableSaveButton$: Subject<boolean> = new Subject<boolean>()
  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private actions$: Actions,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.organizationService.showModal) {
      this.activeRoute.params.pipe(take(1)).subscribe((params) => {
        if (params.hasOwnProperty('organizationId')) {
          this.organizationId$ = of(Number(params['organizationId']))
        }
      })
    } else {
      this.organizationId$ = this.store
        .select(organizationSelectors.selectIdRouteParam)
        .pipe(filter((id) => Boolean(id)))
    }

    this.organization$ = this.organizationId$.pipe(
      switchMap((organizationId) => {
        this.store.dispatch(
          organizationActions.fetchOneById({
            id: organizationId,
            params: RequestQueryBuilder.create({
              join: [
                { field: 'tags' },
                { field: 'addresses' },
                { field: 'documents' },
                { field: 'primaryAddress' },
                { field: 'invoiceAddress' },
                { field: 'roles' },
                { field: 'userRoles' },
                { field: 'userRoles.organization' },
                { field: 'userRoles.member' },
                { field: 'userRoles.member.role' },
                { field: 'userRoles.member.subscribers' },
                { field: 'requiredSubscriptions' }
              ]
            })
          })
        )
        return this.store.select(
          organizationSelectors.selectById,
          organizationId
        )
      })
    )
    this.disableSaveButton$.next(false)
  }

  public onSubmit(form): void {
    delete form?.address
    this.organizationId$.pipe(take(1)).subscribe((organizationId) =>
      this.store.dispatch(
        organizationActions.updateOneById({
          id: organizationId,
          params: {
            ...form,
            id: parseInt(organizationId.toString())
          }
        })
      )
    )

    this.actions$
      .pipe(
        ofType(organizationActions.upsertMany),
        take(1),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((action) => {
        this.disableSaveButton$.next(false)
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      })
  }
}
